// 매출 통계 섹션 URL (2026-09-05 KST 추가)
const salesStatsSection = "/sales-stats";

export const salesStatsPath = salesStatsSection;
export const productSalesPath = `${salesStatsSection}/products`;
